import React, { useState,useEffect } from 'react'
import { connect } from 'react-redux';
import { validateContactNo } from '../../common/validation';
import Footer from '../../components/footer/Footer';
import Header from '../../components/header/Header';
import MenuBar from '../../components/menu-bar/MenuBar';
import Loader from "react-loader-spinner";
import {
    UpdateCartCount,
    UpdateCartAmount
} from "../../redux/actions/postActions";
import { WebApiCalls } from '../../webApiCalls/webApiCalls';
import { Md5 } from 'md5-typescript';
function ResetPassword(props) {
    const [mobileNo, setMobileNo] = useState('')
    const [noMobileNo, setNoMobileNo] = useState(false)
    const [is_loading, setIsLoading] = useState(false)
    const [show_phone_error, set_show_phone_error] = useState(false)
    useEffect(() => {
        const listener = event => {
          if (event.code === "Enter" || event.code === "NumpadEnter") {
            event.preventDefault();
            ResetPassword()
          }
        };
        document.addEventListener("keydown", listener);
        return () => {
          document.removeEventListener("keydown", listener);
        };
      }, [mobileNo]);
    const handlePhoneInput = (event) => {
        setMobileNo(event.target.value)
        setNoMobileNo(false)
        let valid = validateContactNo(event.target.value);
        set_show_phone_error(!valid)
    };
    const ErrorView = (_text) => {
        return (<div className="error" style={{ display: "block", marginTop: 10 }}>{_text}</div>)
    }
    const ResetPassword = () => {
        setIsLoading(true)
        if (show_phone_error) {
            setTimeout(() => {
                setIsLoading(false)
            }, 500);
            return
        }
        if (mobileNo == '') {
            setNoMobileNo(true)
            setIsLoading(false)
            return
        }
        let c = mobileNo + "#frasers"
        let checksum = Md5.init(c)
        new WebApiCalls().recoverCredentialsMobile(mobileNo, checksum).then(result => {
            console.log('result = ', result)
            props?.history?.push("/verify-otp", {
                verification_code: result?.data?.verification_code,
                mobile:mobileNo,
                from:'resetpassword'
            })
        })

    }

    return (
        <div>
            <div className="viewport"></div>

            {/* /container */}
            <div className="container">

                {/* header */}
                <Header props={props} />
                {/* /header */}



                <MenuBar props={props} categoriesArray={props?.allCategories ? props?.allCategories : []}/>

                {/* login */}
                <div className="login">
                    <div className="title">Reset your password</div>
                    <div className="subtitle">Please enter your mobile no. to reset your password</div>

                    <form name="resetpw">

                        <fieldset>
                            <label htmlFor="">MOBILE NO.</label>
                            <input type="text" name="mobileno" id="mobileno" onChange={handlePhoneInput} />
                            {noMobileNo == true &&
                                ErrorView("Please enter mobile number")}
                            {show_phone_error == true &&
                                ErrorView("This does not look like a valid mobile number")}
                        </fieldset>
                        <div onClick={(event) => {
                            event.preventDefault()
                            ResetPassword()
                        }} className="loadingBlackButton">
                            {
                                is_loading ?
                                    <Loader
                                        type="TailSpin"
                                        color="white"
                                        height={18}
                                        width={18}
                                    />
                                    :
                                    "NEXT"}
                        </div>
                    </form>

                    <div className="greynote">
                        A one-time password (OTP) will be sent via SMS to this mobile no. for verification.
                        <br /><br />
                        If you experience any difficulties verifying your account, please <a target='_blank' href="mailto:help@frasersestore.com">contact us</a> for assistance.
                    </div>


                    <div className="join noline">
                        <a onClick={() => {
                            props?.history?.push("/login", { from: 'Reset Password' })
                        }}
                        >Back to Sign In Page</a>
                    </div>

                </div>
                {/* /login */}

            </div>
            {/* /container */}

            <Footer categoriesArray={props?.allCategories ? props?.allCategories : []}/>


        </div>
    )
}
const mapStateToProps = (state) => {
    const { cart_count,allCategories } = state.UserReducer
    return { cart_count,allCategories }
};
const actions = {
    UpdateCartCount,
    UpdateCartAmount
};
export default connect(mapStateToProps, actions)(ResetPassword);